export default "https://cdn-gra.amplement.io/statics/images/browsers/opera.png";